module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDEyIDE1Ij4KICA8cGF0aCBpZD0iUGF0aF8xIiBkYXRhLW5hbWU9IlBhdGggMSIgZD0iTTcuNSwwLDE1LDEySDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDE1KSByb3RhdGUoLTkwKSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon-rectangle.svg
// module id = tpWj
// module chunks = 0